var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "	Thema erfassen\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.admin : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.program(6, data, 0),"data":data})) != null ? stack1 : "");
},"4":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "	Thema "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.issue : depth0)) != null ? stack1.id : stack1), depth0))
    + " bearbeiten\n";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda;

  return "	Thema "
    + container.escapeExpression(alias1(((stack1 = (depth0 != null ? depth0.issue : depth0)) != null ? stack1.id : stack1), depth0))
    + ": "
    + ((stack1 = alias1(((stack1 = (depth0 != null ? depth0.issue : depth0)) != null ? stack1.projectName : stack1), depth0)) != null ? stack1 : "")
    + " - "
    + ((stack1 = alias1(((stack1 = (depth0 != null ? depth0.issue : depth0)) != null ? stack1.name : stack1), depth0)) != null ? stack1 : "")
    + "\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return ((stack1 = helpers["if"].call(alias1,__default(require("../../../../common/js/handlebars/empty.js")).call(alias1,(depth0 != null ? depth0.issue : depth0),{"name":"empty","hash":{},"data":data}),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "");
},"useData":true});